// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Site_TemplateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /site/v1/templates/{formulario} — read from the query string.
 *
 * `unidade` is NOT validated against the units: it arrives from a visitor's browser through the
 * site, and a slug that matches nothing simply keeps the template's own recipients. A lead must
 * still reach somebody.
 */
import { registerContract } from './validate'

export interface Site_TemplateInput {
unidade?: string
}

registerContract('Site_TemplateInput', {
  unidade: { type: 'string',  required: false },
})
